module.exports = __webpack_public_path__ + "static/media/sample_companies.7139c5e2.csv";